module.exports = __webpack_public_path__ + "PatinEB00v.png?a7aad4b01e9ac86355de58eebd8c2fdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PatinEB00v.png
// module id = 2617
// module chunks = 0